import { action, computed, makeObservable, observable } from 'mobx'
import { PDFDocumentProxy } from 'pdfjs-dist'

import DeliveryStatus from '~/client/src/shared/constants/DeliveryStatus'

import { GET_PDF_BLOB_URL } from '../../stores/EventStore/eventConstants'
import EventsStore from '../../stores/EventStore/Events.store'

export interface IFullscreenPreviewComment {
  authorId: string
  text: string
  companyName: string
  timestamp: number
  deliveryStatus?: DeliveryStatus
  photoDetails?: string[]
}
export const MAX_SCALE = 10
export const MIN_SCALE = 0.05
const SCALE_STEP = 0.05

export default class FileFullscreenPreviewStore {
  @observable public scale: number = 1
  @observable public url: string = ''
  @observable public blobUrl: string = ''
  @observable public pageNumber: number = 1
  @observable public shouldFitToWidth: boolean = false

  @observable private totalPages: number = 1

  public constructor(private readonly eventsStore: EventsStore) {
    makeObservable(this)
  }

  @action.bound
  public openNextPage(event: React.MouseEvent) {
    event.stopPropagation()
    if (this.pageNumber === this.totalPages) {
      this.pageNumber = 1
    } else {
      this.pageNumber++
    }
  }

  @action.bound
  public openPrevPage(event: React.MouseEvent) {
    event.stopPropagation()
    if (this.pageNumber === 1) {
      this.pageNumber = this.totalPages
    } else {
      this.pageNumber--
    }
  }

  @action.bound
  public scaleIn() {
    if (this.scale + SCALE_STEP > MAX_SCALE) {
      this.scale = MAX_SCALE
    } else {
      this.scale += SCALE_STEP
    }
  }

  @action.bound
  public scaleOut() {
    if (this.scale - SCALE_STEP < MIN_SCALE) {
      this.scale = MIN_SCALE
    } else {
      this.scale -= SCALE_STEP
    }
  }

  @action.bound
  public scaleToFit() {
    this.scale = 1
    this.shouldFitToWidth = !this.shouldFitToWidth
  }

  @action.bound
  public onScaleChanged(scale: number) {
    this.scale = scale
  }

  @action.bound
  public setBlobUrl(blob: Blob) {
    this.blobUrl = URL.createObjectURL(blob)
  }

  @action
  public updateFileUrls(url: string) {
    this.url = url
    this.eventsStore.dispatch(GET_PDF_BLOB_URL, this.url, this.setBlobUrl)
  }

  @action.bound
  public onDocumentLoadSuccess(doc: PDFDocumentProxy) {
    this.totalPages = doc.numPages
  }

  @computed
  public get pagesLabel(): string {
    return `${this.pageNumber}/${this.totalPages}`
  }
}
